import type {
  BooksHealthRepository,
  GetBooksHealthOverviewParams,
} from "../../domain/repositories/BooksHealthRepository";
import type { BooksHealthOverviewEntity } from "../../domain/entities/BooksHealthEntity";
import type { ActionRequiredItemEntity } from "../../domain/entities/BooksHealthEntity";
import {
  getBooksHealthActionRequired as fetchBooksHealthActionRequired,
  getBooksHealthMonthByMonth as fetchBooksHealthMonthByMonth,
  getBooksHealthMonthlyModuleStatus as fetchBooksHealthMonthlyModuleStatus,
  getBooksHealthOverview as fetchBooksHealthOverview,
  getBooksHealthRecentActivity as fetchBooksHealthRecentActivity,
  getBooksHealthSummary as fetchBooksHealthSummary,
} from "../api/booksHealthApi";
import {
  actionRequiredItemDtoToEntity,
  booksHealthSummaryDtoToEntity,
  booksHealthOverviewDtoToEntity,
  booksMonthStatusItemDtoToEntity,
  monthlyModuleStatusDtoToEntity,
  recentBooksActivityDtoToEntity,
} from "../mappers/booksHealthMapper";

export class BooksHealthRepositoryImpl implements BooksHealthRepository {
  async getBooksHealthOverview(
    params?: GetBooksHealthOverviewParams,
  ): Promise<BooksHealthOverviewEntity> {
    const dto = await fetchBooksHealthOverview({
      month: params?.month,
      year: params?.year,
    });
    return booksHealthOverviewDtoToEntity(dto);
  }

  async getBooksHealthActionRequired(): Promise<ActionRequiredItemEntity[]> {
    const dto = await fetchBooksHealthActionRequired();
    return dto.map(actionRequiredItemDtoToEntity);
  }

  async getBooksHealthSummary() {
    const dto = await fetchBooksHealthSummary();
    return booksHealthSummaryDtoToEntity(dto);
  }

  async getBooksHealthMonthByMonth(limit = 12) {
    const dto = await fetchBooksHealthMonthByMonth(limit);
    return dto.map(booksMonthStatusItemDtoToEntity);
  }

  async getBooksHealthMonthlyModuleStatus() {
    const dto = await fetchBooksHealthMonthlyModuleStatus();
    return dto.map(monthlyModuleStatusDtoToEntity);
  }

  async getBooksHealthRecentActivity() {
    const dto = await fetchBooksHealthRecentActivity();
    return dto.map(recentBooksActivityDtoToEntity);
  }
}
